export const CHANGE_FILTER = 'RANKING_CHANGE_FILTER'
export const SEARCH_USER = 'RANKING_SEARCH_USER'
export const SELECT_FEDERATION = 'RANKING_SELECT_FEDERATION'
export const SEND_MESSAGE = 'RANKING_SEND_MESSAGE'
export const SEND_MESSAGE_OK = 'RANKING_SEND_MESSAGE_OK'
export const SEND_MESSAGE_ERROR = 'RANKING_SEND_MESSAGE_ERROR'
export const SET_CHAT_TARGET = 'RANKING_SET_CHAT_TARGET'

export const changeFilter = (filter) => {
  return { type: CHANGE_FILTER, data: filter }
}
export const searchUser = (search) => {
  return { type: SEARCH_USER, data: search }
}
export const selectFederation = (federationId) => {
  return { type: SELECT_FEDERATION, data: federationId }
}
export const sendMessage = (data) => {
  return { type: SEND_MESSAGE, data: data }
}
export const sendMessageOk = () => {
  return { type: SEND_MESSAGE_OK }
}
export const sendMessageError = (error) => {
  return { type: SEND_MESSAGE_ERROR, data: error }
}
export const setChatTarget = (error) => {
  return { type: SET_CHAT_TARGET, data: error }
}
